import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './components/Router/index';
import Footer from './components/Footer/index';
import Header from './components/Header/index';
import 'semantic-ui/dist/semantic.min.css';
import './App.css';

class App extends Component {
  state = {
    route: (window.location.pathname !== '/' ? false : true )
  }

  constructor(props) {
    super(props)
    this.handler = this.handler.bind(this)
  }

  handler( bool ) {
      this.setState({ route: bool })
  }

 render() {
   return (
     <BrowserRouter>
       <div className={"App " + (this.state.route ? 'OxfordBackground' : 'DefaultBackground')}>
         <Header/>
         <AppRouter handler={ this.handler } />
         <Footer/>
       </div>
     </BrowserRouter>

   );
 }
}

export default App;
